import Index from "@/pages/index";
import auth from "./middleware/authMiddleware.js";
import redirectFav from "./middleware/redirectFavMiddleware.js";
import loginRoute from "./routes/loginRoute.js";
import profileRoute from "./routes/profileRoute.js";
import dashboardRoute from "./routes/dashboardRoute.js";
import nodeRoutes from "./routes/nodeRoutes.js";
import adminRoutes from "./routes/adminRoutes.js";
import specialRoutes from "./routes/specialRoutes.js";

export default [
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: { middleware: [auth, redirectFav] },
    children: [
      profileRoute,
      dashboardRoute,
      ...nodeRoutes,
      ...adminRoutes,
      ...specialRoutes
    ]
  },

  // Маршруты авторизации
  loginRoute,

  // Редирект с несуществующих маршрутов
  {
    path: "*",
    redirect: { name: "Index" }
  }
];
